export const MODAL_HEADING_TEXT = `Пожалуйста, подтвердите, что вы человек`;
export const BUTTON_TEXT = `Подтвердить`;
